import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import packageJSON from '../../../../../package.json';
import CreditCurrencyLogo from '../../../../assets/target/images/CreditCurrencyLogo.svg';
import Button from '../../../../components/Button';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';

import { createRootModal } from '../../RootModal';
import './BillingDetail.scss';

const { routes } = AppConfig;

const CREDIT_CURRENCY = packageJSON?.creditCurrency ?? 'Credits';
const DESCRIPTION_ICON_SIZE = 24;

const descriptionList = [
	{
		icon: Icons.GAS_STATION,
		label: 'Commission payment',
		text: "You can pay outgoing transaction fees with up to 50% discount using BH USD.\nTry it — it's easy!",
	},
	{
		icon: Icons.RISK_LEVEL,
		label: 'AML check payment',
		text: 'AML checks provide risk assessment information required for compliance procedures. \nInitiate an AML check to obtain risk assessment information.',
	},
	{
		icon: Icons.LIGHTNING,
		label: 'To be announced',
	},
];

const BillingDetail = createRootModal(() => {
	const { showByButton } = useSelector(state => state.app.modal.outsideParams);

	const navigate = useNavigate();

	const buyBilling = () => {
		navigate({ pathname: routes.billingAsset });
	};

	return (
		<div className='BillingDetail'>
			<div className='BillingDetail__glow'></div>
			<img src={CreditCurrencyLogo} alt='billing-logo' className='BillingDetail__logo' />
			<div className='BillingDetail__header'>{t('What is {currency} for', { currency: CREDIT_CURRENCY })}</div>
			<div className='BillingDetail__subheader'>{t('{currency} usage options', { currency: CREDIT_CURRENCY })}</div>
			<div className='BillingDetail__descriptions'>
				{descriptionList.map(description => (
					<div className='BillingDetail__description'>
						<div className='BillingDetail__description-header'>
							<Icon type={description.icon} width={DESCRIPTION_ICON_SIZE} height={DESCRIPTION_ICON_SIZE} />
							<div className='BillingDetail__description-label'>{t(description.label)}</div>
						</div>
						{description.text && <div className='BillingDetail__description-text'>{t(description.text)}</div>}
					</div>
				))}
			</div>
			{showByButton && (
				<Button className='BillingHistory__buy-button' onClick={buyBilling}>
					{t('Buy {currency}', { currency: CREDIT_CURRENCY })}
				</Button>
			)}
		</div>
	);
});

export default BillingDetail;
